import { create } from 'zustand'
import type { ChatStreamStatus } from '@/shared/realtime/chatEventStream'

export type ChatTriage = 'unread' | 'all' | 'broadcasts'

type ChatUiState = {
  dockOpen: boolean
  selectedConversationId: number | null
  visibleConversationId: number | null
  streamStatus: ChatStreamStatus
  accessEnded: boolean
  triage: ChatTriage
  composerFocusRequested: boolean
  selectedBroadcastId: number | null
  composingBroadcast: boolean
  selectBroadcast: (id: number | null) => void
  composeBroadcast: () => void
  setDockOpen: (open: boolean) => void
  toggleDock: () => void
  setSelectedConversation: (id: number | null) => void
  setVisibleConversation: (id: number | null) => void
  setStreamStatus: (status: ChatStreamStatus) => void
  setAccessEnded: (ended: boolean) => void
  setTriage: (triage: ChatTriage) => void
  setComposerFocusRequested: (requested: boolean) => void
  reset: () => void
}

export const useChatUiStore = create<ChatUiState>((set) => ({
  dockOpen: false,
  selectedConversationId: null,
  visibleConversationId: null,
  streamStatus: 'connecting',
  accessEnded: false,
  triage: 'unread',
  composerFocusRequested: false,
  selectedBroadcastId: null,
  composingBroadcast: false,
  selectBroadcast: (selectedBroadcastId) => set({ selectedBroadcastId, composingBroadcast: false }),
  composeBroadcast: () => set({ composingBroadcast: true, selectedBroadcastId: null }),
  setDockOpen: (dockOpen) => set({ dockOpen }),
  toggleDock: () => set((state) => ({ dockOpen: !state.dockOpen })),
  setSelectedConversation: (selectedConversationId) => set({ selectedConversationId }),
  setVisibleConversation: (visibleConversationId) => set({ visibleConversationId }),
  setStreamStatus: (streamStatus) => set({ streamStatus }),
  setAccessEnded: (accessEnded) => set({ accessEnded }),
  setTriage: (triage) => set({ triage }),
  setComposerFocusRequested: (composerFocusRequested) => set({ composerFocusRequested }),
  reset: () =>
    set({
      dockOpen: false,
      selectedConversationId: null,
      visibleConversationId: null,
      streamStatus: 'connecting',
      accessEnded: false,
      triage: 'unread',
      composerFocusRequested: false,
      selectedBroadcastId: null,
      composingBroadcast: false,
    }),
}))
